import { UserViewMode } from '@/store/modules/auth/type'

export type HeaderViewMode = UserViewMode.Bu | UserViewMode.Broker

export function getDefaultHeaderViewMode(canUseBuView: boolean): HeaderViewMode {
  return canUseBuView ? UserViewMode.Bu : UserViewMode.Broker
}

export function normalizeStringValue(value: unknown, fallback = '') {
  if (value == null) {
    return fallback
  }

  return String(value)
}

export function normalizeNumberValue(value: unknown, fallback: number) {
  const nextValue = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(nextValue) ? nextValue : fallback
}

export function normalizeHeaderViewMode(value: unknown, canUseBuView: boolean): HeaderViewMode {
  if (value === UserViewMode.Bu || value === 2 || value === '2' || value === 'BU_VIEW') {
    return canUseBuView ? UserViewMode.Bu : UserViewMode.Broker
  }

  return UserViewMode.Broker
}

export function normalizeBuId(value: unknown, defaultBuId = '') {
  const normalizedValue = normalizeStringValue(value)
  return normalizedValue || defaultBuId || ''
}
